var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppLoading'),_vm._v(" "),_c('main',{staticClass:"main",attrs:{"data-ma-theme":"blue"}},[_c('AppHeader'),_vm._v(" "),_c('AppSidebar'),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e9d558","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/layout.vue
// module id = null
// module chunks = 